var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ag-cell-label-container",class:{ 'date-field': _vm.isDate },attrs:{"role":"presentation","data-testid":"grid-header-drilldown"},on:{"click":_vm.onClick}},[_c('div',{ref:"eLabel",staticClass:"ag-header-cell-label",attrs:{"role":"presentation"}},[_vm._v(" "+_vm._s(_vm.params.displayName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }